import api from './axios';

// =============== SUCCESS STORIES ===============

// Get all success stories (with optional filters)
export const getSuccessStories = async (params = {}) => {
  const response = await api.get('/alumni/success-stories', { params });
  return response.data;
};

// Get single success story
export const getSuccessStory = async (id) => {
  const response = await api.get(`/alumni/success-stories/${id}`);
  return response.data;
};

// Create success story (admin - with image upload)
export const createSuccessStory = async (formData) => {
  const response = await api.post('/alumni/success-stories', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update success story (admin - with optional image upload)
export const updateSuccessStory = async (id, formData) => {
  const response = await api.patch(`/alumni/success-stories/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Delete success story (admin)
export const deleteSuccessStory = async (id) => {
  const response = await api.delete(`/alumni/success-stories/${id}`);
  return response.data;
};

// Submit success story (public - pending approval)
export const submitStory = async (formData) => {
  const response = await api.post('/alumni/submit-story', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Approve success story (admin)
export const approveStory = async (id) => {
  const response = await api.patch(`/alumni/success-stories/${id}/approve`);
  return response.data;
};

// =============== TESTIMONIALS ===============

// Get all testimonials
export const getTestimonials = async (params = {}) => {
  const response = await api.get('/alumni/testimonials', { params });
  return response.data;
};

// Submit testimonial (public)
export const submitTestimonial = async (formData) => {
  const response = await api.post('/alumni/testimonials', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update testimonial (admin)
export const updateTestimonial = async (id, data) => {
  const response = await api.patch(`/alumni/testimonials/${id}`, data);
  return response.data;
};

// Delete testimonial (admin)
export const deleteTestimonial = async (id) => {
  const response = await api.delete(`/alumni/testimonials/${id}`);
  return response.data;
};

// =============== STATISTICS ===============

// Get all statistics
export const getStatistics = async () => {
  const response = await api.get('/alumni/statistics');
  return response.data;
};

// Create statistic (admin)
export const createStatistic = async (data) => {
  const response = await api.post('/alumni/statistics', data);
  return response.data;
};

// Update statistic (admin)
export const updateStatistic = async (id, data) => {
  const response = await api.patch(`/alumni/statistics/${id}`, data);
  return response.data;
};

// Delete statistic (admin)
export const deleteStatistic = async (id) => {
  const response = await api.delete(`/alumni/statistics/${id}`);
  return response.data;
};

// =============== ALUMNI REGISTRATION ===============

// Alumni registration (public)
export const registerAlumni = async (data) => {
  const response = await api.post('/alumni/register', data);
  return response.data;
};

// Get all registrations (admin)
export const getRegistrations = async (params) => {
  const response = await api.get('/alumni/registrations', { params });
  return response.data;
};

// Update registration status (admin)
export const updateRegistration = async (id, data) => {
  const response = await api.patch(`/alumni/registrations/${id}`, data);
  return response.data;
};

// Delete registration (admin)
export const deleteRegistration = async (id) => {
  const response = await api.delete(`/alumni/registrations/${id}`);
  return response.data;
};

const alumniService = {
  // Success Stories
  getSuccessStories,
  getSuccessStory,
  createSuccessStory,
  updateSuccessStory,
  deleteSuccessStory,
  submitStory,
  approveStory,
  
  // Testimonials
  getTestimonials,
  submitTestimonial,
  updateTestimonial,
  deleteTestimonial,
  
  // Statistics
  getStatistics,
  createStatistic,
  updateStatistic,
  deleteStatistic,
  
  // Registration
  registerAlumni,
  getRegistrations,
  updateRegistration,
  deleteRegistration,
};

export default alumniService;
